module.exports = __webpack_public_path__ + "img/21.b5a40204.jpg";